import React from 'react'
import { useResume } from '../ResumeProvider'
import { EditableHeading } from './common'
import { useTemplate } from '~/lib/pdf'
import { EditorTextArea, EditorItemProvider } from './EditorItemProvider'
import AiSummary from './AiSummary'
import { useTranslation } from '~/hooks/useTranslation'

const SummaryEditor = () => {
  const { resumeDocument: { basics } = {} } = useResume()
  const { editorFieldEnabled } = useTemplate()
  const { t } = useTranslation('SummaryEditor')

  if (!editorFieldEnabled('basicsSummary')) return null

  return (
    <EditorItemProvider sectionName="basics" item={basics}>
      <div>
        <div className="mb-4 flex flex-row">
          <EditableHeading
            title={t('professional_summary')}
            description={t('summary_description')}
            settingName="summaryHeading"
          />
        </div>
        <div className="flex flex-col gap-y-4">
          {/* CTS-9213 — label: textarea was unlabeled when no label prop passed */}
          <EditorTextArea
            autoExpand={true}
            fieldName="summary"
            areaClassName="h-40"
            label={t('professional_summary')}
            labelClassName="sr-only"
          />
          <AiSummary />
        </div>
      </div>
    </EditorItemProvider>
  )
}
export default SummaryEditor
